import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { UserFullProfileDto } from "../../../models/user/dto/user.dto";

export const GET_USER_BY_ID_QUERY_KEY = (id:string)=>['users', id];
export const useGetUser = (id: string) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_USER_BY_ID_QUERY_KEY(id),
        queryFn: () => client.fetchApi<UserFullProfileDto, {}>({ endpoint: `users/${id}/details`, method: 'GET' }),
        enabled: Boolean(id)
    });
};